'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errors = require('../errors.js');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:repo:lock:memory');
var lockFile = 'repo.lock';
var LOCKS = {};

function lock(_x) {
  return _lock.apply(this, arguments);
}

function _lock() {
  _lock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dir) {
    var file, closer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            file = dir + '/' + lockFile;
            log('locking %s', file);

            if (!(LOCKS[file] === true)) {
              _context2.next = 4;
              break;
            }

            throw new errors.LockExistsError("Lock already being held for file: ".concat(file));

          case 4:
            LOCKS[file] = true;
            closer = {
              close: function close() {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (LOCKS[file]) {
                            delete LOCKS[file];
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))();
              }
            };
            return _context2.abrupt("return", closer);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _lock.apply(this, arguments);
}

function locked(_x2) {
  return _locked.apply(this, arguments);
}

function _locked() {
  _locked = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dir) {
    var file;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            file = dir + '/' + lockFile;
            log("checking lock: ".concat(file));
            return _context3.abrupt("return", Boolean(LOCKS[file]));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _locked.apply(this, arguments);
}

var MemoryLock = {
  lock: lock,
  locked: locked
};
exports.MemoryLock = MemoryLock;